<template>
  <div class="container about-page">
    <header class="about-header">
      <h1><i class="ri-user-smile-line"></i> 关于我</h1>
      <p class="about-subtitle">一个持续学习 AI 的开发者</p>
    </header>

    <!-- 个人简介 -->
    <div class="about-card about-intro">
      <div class="about-avatar"><i class="ri-user-6-line"></i></div>
      <div class="about-intro-text">
        <p>
          这个站点是我的<b>个人学习网站</b>，每天用 AI 辅助整理一篇学习笔记，
          记录在 <b>LLM / RAG / Agent / 微调 / 多模态</b>等方向上的积累。
        </p>
        <p class="about-intro-sub">学习是件长期的事，这里是我的公开成长记录。</p>
      </div>
    </div>

    <!-- 学习方向 + 技术栈 并排 -->
    <div class="about-row">
      <div class="about-card about-half">
        <h2><i class="ri-crosshair-2-line"></i> 学习方向</h2>
        <div class="about-tags">
          <span class="about-tag">LLM 原理</span>
          <span class="about-tag">RAG</span>
          <span class="about-tag">Agent</span>
          <span class="about-tag">模型微调</span>
          <span class="about-tag">向量数据库</span>
          <span class="about-tag">多模态</span>
        </div>
      </div>
      <div class="about-card about-half">
        <h2><i class="ri-tools-line"></i> 技术栈</h2>
        <div class="about-tags">
          <span class="about-tag">Java</span>
          <span class="about-tag">Spring Boot</span>
          <span class="about-tag">Spring Cloud</span>
          <span class="about-tag">MySQL</span>
          <span class="about-tag">Redis</span>
          <span class="about-tag">Vue</span>
          <span class="about-tag">Electron</span>
          <span class="about-tag">Docker</span>
          <span class="about-tag">K8s</span>
          <span class="about-tag">Nginx</span>
        </div>
      </div>
    </div>

    <!-- 联系我 + 关于本站 并排 -->
    <div class="about-row">
      <div class="about-card about-half">
        <h2><i class="ri-mail-line"></i> 联系我</h2>
        <a class="about-link" href="mailto:dawnstarwu@icloud.com">
          <i class="ri-mail-line"></i> dawnstarwu@icloud.com
        </a>
      </div>
      <div class="about-card about-half">
        <h2><i class="ri-leaf-line"></i> 关于本站</h2>
        <ul class="about-list">
          <li>每日一篇 AI 学习笔记，坚持输出</li>
          <li>每日精选推荐，追踪前沿资讯</li>
          <li>页面里偶尔会有小动物来访 🐾</li>
        </ul>
      </div>
    </div>

    <div class="about-back-bar">
      <a class="back-link" @click="goHome"><i class="ri-arrow-left-s-line"></i> 返回首页</a>
    </div>

    <footer>
      <p>AI 学习笔记 · 个人学习总结</p>
      <div class="beian">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">闽ICP备2026026930号-1</a>
        <br>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=35010202002243" target="_blank" rel="noopener noreferrer">
          <img src="/static/beian-logo.png" style="vertical-align:middle;width:16px;height:16px;margin-right:4px;" alt="公安备案标识" />
          闽公网安备35010202002243号
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  methods: {
    goHome () {
      window.location.hash = '#/'
    }
  }
}
</script>
